import { render, staticRenderFns } from "./EditThreadPage.vue?vue&type=template&id=299ae82e&scoped=true"
import script from "./EditThreadPage.vue?vue&type=script&lang=js"
export * from "./EditThreadPage.vue?vue&type=script&lang=js"
import style0 from "./EditThreadPage.vue?vue&type=style&index=0&id=299ae82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ae82e",
  null
  
)

export default component.exports